import styled from 'styled-components';

const ButtonStyled = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
  border: 2px solid ${({ theme }) => theme.primaryColor};
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 16px;
  line-height: 20px;
  background: #fff;
  color: ${({ theme }) => theme.primaryColor};
  font-size: ${({ theme }) => theme.fontSize.sm};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: ${({ theme }) => theme.btnTextWeigth};

  &:focus {
    outline: none;
  }

  &.loading {
    color: transparent;
    user-select: none;
    cursor: no-drop;

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    &:after {
      border: 2px solid ${({ theme }) => theme.primaryColor};
      border-width: 4px;
      border-radius: 100%;
      border-right-color: transparent;
      border-top-color: transparent;
      content: '';
      animation: rotate 500ms infinite linear;
      display: block;
      height: 18px;
      width: 18px;
      position: absolute;
    }
  }
`;

export default ButtonStyled;
export { ButtonStyled };
